export const isInRange = (value: number, start: number, end: number) =>
  value >= start && value <= end;
